/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type HfbParameterDto,
    HfbParameterDtoFromJSON,
    HfbParameterDtoToJSON,
} from '../models/HfbParameterDto';
import {
    type ParameterDto,
    ParameterDtoFromJSON,
    ParameterDtoToJSON,
} from '../models/ParameterDto';

export interface PostDivisionDefaultParametersRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Division ID
     */
    divId: string;
    /**
     * List of parameters and their new values
     */
    parameterDto: Array<ParameterDto>;
}

export interface PostF6ParametersRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * List of parameters and their new values
     */
    parameterDto: Array<ParameterDto>;
}

export interface PostHfbDefaultParametersRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * List of parameters and their new values
     */
    hfbParameterDto: HfbParameterDto;
}

export interface PostParametersForItemsRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Level type
     */
    filter: string;
    /**
     * Level ID
     */
    filterValue: string;
    /**
     * Single parameters and the new value
     */
    parameterDto: ParameterDto;
}

export interface PostParametersForSingleItemRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Item number
     */
    itemNo: string;
    /**
     * List of parameters and their new values
     */
    parameterDto: Array<ParameterDto>;
}

export interface PostStoreDefaultParametersRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * List of parameters and their new values
     */
    parameterDto: Array<ParameterDto>;
}

/**
 * 
 */
export class POSTParametersApi extends runtime.BaseAPI {

    /**
     * Creates request options for postDivisionDefaultParameters without sending the request
     */
    async postDivisionDefaultParametersRequestOpts(requestParameters: PostDivisionDefaultParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling postDivisionDefaultParameters().'
            );
        }

        if (requestParameters['divId'] == null) {
            throw new runtime.RequiredError(
                'divId',
                'Required parameter "divId" was null or undefined when calling postDivisionDefaultParameters().'
            );
        }

        if (requestParameters['parameterDto'] == null) {
            throw new runtime.RequiredError(
                'parameterDto',
                'Required parameter "parameterDto" was null or undefined when calling postDivisionDefaultParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/defaults/division/{divId}`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));
        urlPath = urlPath.replace('{divId}', encodeURIComponent(String(requestParameters['divId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['parameterDto']!.map(ParameterDtoToJSON),
        };
    }

    /**
     * Updates the default values of the parameters on division level
     * Update the parameter values on division level
     */
    async postDivisionDefaultParametersRaw(requestParameters: PostDivisionDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postDivisionDefaultParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the default values of the parameters on division level
     * Update the parameter values on division level
     */
    async postDivisionDefaultParameters(requestParameters: PostDivisionDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postDivisionDefaultParametersRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postF6Parameters without sending the request
     */
    async postF6ParametersRequestOpts(requestParameters: PostF6ParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling postF6Parameters().'
            );
        }

        if (requestParameters['parameterDto'] == null) {
            throw new runtime.RequiredError(
                'parameterDto',
                'Required parameter "parameterDto" was null or undefined when calling postF6Parameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/f6`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['parameterDto']!.map(ParameterDtoToJSON),
        };
    }

    /**
     * Update the list of SLM F6 parameters for a store
     * Updates the value of F6 parameters
     */
    async postF6ParametersRaw(requestParameters: PostF6ParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postF6ParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the list of SLM F6 parameters for a store
     * Updates the value of F6 parameters
     */
    async postF6Parameters(requestParameters: PostF6ParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postF6ParametersRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postHfbDefaultParameters without sending the request
     */
    async postHfbDefaultParametersRequestOpts(requestParameters: PostHfbDefaultParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling postHfbDefaultParameters().'
            );
        }

        if (requestParameters['hfbParameterDto'] == null) {
            throw new runtime.RequiredError(
                'hfbParameterDto',
                'Required parameter "hfbParameterDto" was null or undefined when calling postHfbDefaultParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/defaults/hfb`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HfbParameterDtoToJSON(requestParameters['hfbParameterDto']),
        };
    }

    /**
     * Updates the default values of the parameters on hfb level
     * Update the parameter values on hfb level
     */
    async postHfbDefaultParametersRaw(requestParameters: PostHfbDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postHfbDefaultParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the default values of the parameters on hfb level
     * Update the parameter values on hfb level
     */
    async postHfbDefaultParameters(requestParameters: PostHfbDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postHfbDefaultParametersRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postParametersForItems without sending the request
     */
    async postParametersForItemsRequestOpts(requestParameters: PostParametersForItemsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling postParametersForItems().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling postParametersForItems().'
            );
        }

        if (requestParameters['filterValue'] == null) {
            throw new runtime.RequiredError(
                'filterValue',
                'Required parameter "filterValue" was null or undefined when calling postParametersForItems().'
            );
        }

        if (requestParameters['parameterDto'] == null) {
            throw new runtime.RequiredError(
                'parameterDto',
                'Required parameter "parameterDto" was null or undefined when calling postParametersForItems().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['filterValue'] != null) {
            queryParameters['filterValue'] = requestParameters['filterValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/items`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParameterDtoToJSON(requestParameters['parameterDto']),
        };
    }

    /**
     * Update the parameter values that match the filters. Setting a value to NULL resets it to its default.
     * Update the parameters values that match the filters
     */
    async postParametersForItemsRaw(requestParameters: PostParametersForItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postParametersForItemsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the parameter values that match the filters. Setting a value to NULL resets it to its default.
     * Update the parameters values that match the filters
     */
    async postParametersForItems(requestParameters: PostParametersForItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postParametersForItemsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postParametersForSingleItem without sending the request
     */
    async postParametersForSingleItemRequestOpts(requestParameters: PostParametersForSingleItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling postParametersForSingleItem().'
            );
        }

        if (requestParameters['itemNo'] == null) {
            throw new runtime.RequiredError(
                'itemNo',
                'Required parameter "itemNo" was null or undefined when calling postParametersForSingleItem().'
            );
        }

        if (requestParameters['parameterDto'] == null) {
            throw new runtime.RequiredError(
                'parameterDto',
                'Required parameter "parameterDto" was null or undefined when calling postParametersForSingleItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/item/{itemNo}`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));
        urlPath = urlPath.replace('{itemNo}', encodeURIComponent(String(requestParameters['itemNo'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['parameterDto']!.map(ParameterDtoToJSON),
        };
    }

    /**
     * Update the parameter values for the given item number. Setting a value to NULL resets it to its default.
     * Update the parameter values for the given item number
     */
    async postParametersForSingleItemRaw(requestParameters: PostParametersForSingleItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postParametersForSingleItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the parameter values for the given item number. Setting a value to NULL resets it to its default.
     * Update the parameter values for the given item number
     */
    async postParametersForSingleItem(requestParameters: PostParametersForSingleItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postParametersForSingleItemRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postStoreDefaultParameters without sending the request
     */
    async postStoreDefaultParametersRequestOpts(requestParameters: PostStoreDefaultParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling postStoreDefaultParameters().'
            );
        }

        if (requestParameters['parameterDto'] == null) {
            throw new runtime.RequiredError(
                'parameterDto',
                'Required parameter "parameterDto" was null or undefined when calling postStoreDefaultParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/defaults/store`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['parameterDto']!.map(ParameterDtoToJSON),
        };
    }

    /**
     * Updates the default values of the parameters on store level
     * Update the parameter values on store level
     */
    async postStoreDefaultParametersRaw(requestParameters: PostStoreDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postStoreDefaultParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the default values of the parameters on store level
     * Update the parameter values on store level
     */
    async postStoreDefaultParameters(requestParameters: PostStoreDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postStoreDefaultParametersRaw(requestParameters, initOverrides);
    }

}
